import {
  createPattern,
  isSequenceOfKeys,
  isSequenceOfLetters,
  isSequenceOfNumbers,
} from '../../../util/validators'

export const rules = {
  minLength: {
    text: '8 ou mais caracteres',
    regex: /^.{8,}$/,
  },
  uppercase: {
    text: 'Uma letra maiúscula',
    regex: /[A-Z]/,
  },
  lowercase: {
    text: 'Uma letra minúscula',
    regex: /[a-z]/,
  },
  number: {
    text: 'Um número',
    regex: /\d/,
  },
  specialCharacter: {
    text: 'Um caracter especial (exemplo: @ ! $ & #)',
    regex: /[^a-z\d]/i,
  },
}

export const isSomeSequence = password => {
  const passwordPattern = createPattern(password)

  const sequenceValidators = [isSequenceOfNumbers, isSequenceOfKeys, isSequenceOfLetters]

  return sequenceValidators.some(validator => validator(passwordPattern))
}

export const isValidPassword = password => {
  if (isSomeSequence(password)) {
    return false
  }
  return Object.keys(rules).every(rule => rules[rule].regex.test(password))
}
